// — Scroll Fade-in —
(function () {
  const targets = document.querySelectorAll(
    '.shopify-section, .collection-list__item, .product-card'
  );
  targets.forEach(el => el.classList.add('scroll-fade'));

  const observer = new IntersectionObserver(
    entries => entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    }),
    { threshold: 0.12, rootMargin: '0px 0px -20px 0px' }
  );

  targets.forEach(el => {
    // If already in viewport on load, make visible immediately
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('visible');
    } else {
      observer.observe(el);
    }
  });
})();